<template>
  <InputRow v-slot="{ validation: { valid } }" name="creatorFilter" :model-value="selectedIds">
    <LISASelect
      v-model="selectedIds"
      class="w-100"
      multiple
      selection-display="chips"
      :invalid="valid === false"
      :options="selectOptions"
    />
  </InputRow>
</template>

<script setup lang="ts">
import InputRow from "@/components/shared/form/InputRow.vue";
import { computed, ref } from "vue";
import { LISASelect, type LISASelectOption } from "@fi-solutions/lisa-ui";
import PriorityFilter from "../filterImplementations/PriorityFilter";
import { eisenhowerOptions } from "@/components/event-action/event/EventHelper";

const selectedIds = ref<number[]>([]);
const selectOptions = computed<LISASelectOption[]>(() =>
  eisenhowerOptions.value.map((option, id) => ({ id, label: option.label })),
);

function getFilter() {
  return selectedIds.value.length === 0
    ? null
    : new PriorityFilter(
        selectedIds.value.flatMap((id) => {
          const value = eisenhowerOptions.value[id]?.value;
          return value == null ? [] : [value];
        }),
      );
}
function applyFilter(filter: PriorityFilter) {
  selectedIds.value = filter.priorities
    .map((priority) => eisenhowerOptions.value.findIndex((option) => option.value === priority))
    .filter((id) => id >= 0);
}
defineExpose({
  getFilter,
  applyFilter,
});
</script>

<style lang="scss" scoped></style>
